import React, { useContext } from 'react';
import classnames from 'classnames';
import { Typography, Icon } from 'ck-ui';
import { getImgixUrl } from 'ck-utils';
import { useMedia } from 'react-use';
import { BundleLookPrice } from './BundleLookPrice';
import { BundleLookModalToggle } from './BundleLookModalToggle';
import { BundleLookPageContext } from '../context';
import styles from './BundleProgressBar.module.scss';

const LookProgressBar = () => {
  const { groups, onDeleteProduct, addedCount } = useContext(BundleLookPageContext);
  const isWidescreen = useMedia('(min-width: 1440px)');
  const placeHolderCount = 8 - addedCount;

  return (
    <div className={styles.root}>
      <BundleLookModalToggle />
      {isWidescreen && (
        <div className={styles.details}>
          <div className="is-flex">
            {groups.map((group, groupPosition) => group.products.map((product, productPosition) => (
              product.imageUrl && (
                <button
                  /* eslint-disable-next-line react/no-array-index-key */
                  key={`${group.tag}_${productPosition}`}
                  style={{ backgroundImage: `url('${getImgixUrl(product.imageUrl)}')` }}
                  className={styles.product}
                  type="button"
                  onClick={() => onDeleteProduct(groupPosition, productPosition)}
                >
                  <Typography
                    className={classnames('is-flex-centered', 'is-full-width', 'is-full-height', 'is-hidden', styles.remove)}
                    uppercase
                    variant="heading10"
                    align="centered"
                    color="white"
                  >
                    <Icon name="cross" />
                    Remove
                  </Typography>
                </button>
              )
            )))}
            {placeHolderCount >= 0 ? [...Array(placeHolderCount)].map((value, index) => (
              <div
                /* eslint-disable-next-line react/no-array-index-key */
                key={`placeholder_${index}`}
                className={styles.product}
              />
            )) : (
              <div className={classnames(styles.plusMore, 'is-flex-centered')}>
                <Typography variant="heading9">+{Math.abs(placeHolderCount)} MORE</Typography>
              </div>
            )}
          </div>
          <BundleLookPrice />
        </div>
      )}
    </div>
  );
};

export { LookProgressBar };
